import { render, staticRenderFns } from "./Names.vue?vue&type=template&id=f6692f90&scoped=true&"
import script from "./Names.vue?vue&type=script&lang=ts&"
export * from "./Names.vue?vue&type=script&lang=ts&"
import style0 from "./Names.vue?vue&type=style&index=0&id=f6692f90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6692f90",
  null
  
)

export default component.exports